import React from "react";
import { useRecoilValue } from "recoil";
import { indicatorState } from "../../stores/atoms";

function Indicator() {
  const indicator = useRecoilValue(indicatorState);

  return <div className="indicator txt-right txt-black mr-1">{indicator}</div>;
}

export default Indicator;
